var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import styled, { css } from 'styled-components';
import { media } from '@gympass/yoga-helpers';
var mobile = media.xxs(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var grid = _ref.theme.yoga.components.grid;
  return "\n    margin-left: " + grid.container.margin.mobile.left + "px;\n    margin-right: " + grid.container.margin.mobile.right + "px;\n  ";
});
var desktop = media.lg(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref2) {
  var grid = _ref2.theme.yoga.components.grid;
  return "\n    margin-left: " + grid.container.margin.desktop.left + "px;\n    margin-right: " + grid.container.margin.desktop.right + "px;\n  ";
});
var xxxlarge = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref3) {
  var _ref3$theme$yoga$brea = _ref3.theme.yoga.breakpoints.xxxl,
      width = _ref3$theme$yoga$brea.width,
      margin = _ref3$theme$yoga$brea.margin;
  return "\n    @media (min-width: " + (width + margin * 2) + "px) {\n      margin-left: auto;\n      margin-right: auto;\n    }\n  ";
});
var Container = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  box-sizing: border-box;\n  ", "\n"])), function (_ref4) {
  var fluid = _ref4.fluid,
      grid = _ref4.theme.yoga.components.grid;
  return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n    ", "\n  "])), fluid ? 'max-width: 100%;' : css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n          max-width: ", "px;\n          ", "\n          ", "\n          ", "\n        "])), grid.container.width, mobile, desktop, xxxlarge));
});
export default Container;